import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import BrandMark from '../components/BrandMark';
import { authApi } from '../api/authApi';
import { useAuth } from '../context/AuthContext';

export default function VerifyEmailPage() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const { refreshMe, user, logout } = useAuth();
  const navigate = useNavigate();
  const [state, setState] = useState('idle');
  const [error, setError] = useState('');
  const [resendBusy, setResendBusy] = useState(false);
  const [resendMsg, setResendMsg] = useState('');

  useEffect(() => {
    if (!token) return;
    setState('verifying');
    authApi.verifyEmail(token)
      .then(async () => {
        await refreshMe();
        setState('done');
        setTimeout(() => navigate('/app', { replace: true }), 1200);
      })
      .catch((err) => {
        setError(err.message || 'Verification failed');
        setState('error');
      });
  }, [token, refreshMe, navigate]);

  const resend = async () => {
    setResendBusy(true);
    setResendMsg('');
    try {
      await authApi.requestEmailVerification();
      setResendMsg('A new verification email is on its way.');
    } catch (err) {
      setResendMsg(err.message || 'Could not send right now.');
    } finally {
      setResendBusy(false);
    }
  };

  return (
    <div className="auth-shell">
      <div className="auth-card">
        <BrandMark size={28} />
        <h2 className="h2" style={{ marginTop: 18 }}>
          {token ? 'Verifying your email…' : 'Confirm your email'}
        </h2>
        {token ? (
          <>
            {state === 'verifying' && <p className="muted">Just a second.</p>}
            {state === 'done' && <p style={{ color: 'var(--success)' }}>Verified. Taking you to the app.</p>}
            {state === 'error' && <p className="error-text">{error}</p>}
          </>
        ) : (
          <>
            <p className="muted" style={{ marginBottom: 18 }}>
              We sent a verification link to <strong>{user?.email}</strong>. Click it to unlock the app.
              Didn't get it? Resend below.
            </p>
            <button className="btn btn-primary btn-block btn-lg" disabled={resendBusy} onClick={resend}>
              {resendBusy ? 'Sending…' : 'Resend verification email'}
            </button>
            {resendMsg ? <p style={{ marginTop: 12, color: 'var(--accent)' }}>{resendMsg}</p> : null}
            <button className="btn btn-ghost btn-block" style={{ marginTop: 12 }} onClick={async () => { await logout(); navigate('/'); }}>
              Sign out
            </button>
          </>
        )}
      </div>
      <style>{`
        .auth-shell { min-height: 100vh; display: grid; place-items: center; padding: 32px 16px; }
        .auth-card { width: min(460px, 100%); background: var(--panel); border: 1px solid var(--line); border-radius: var(--radius-lg); padding: 28px; }
      `}</style>
    </div>
  );
}
